
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dba",
      function () {
        return require("private-next-pages/dba.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dba"])
      });
    }
  